import { render, staticRenderFns } from "./Stament.vue?vue&type=template&id=04642e0a&"
import script from "./Stament.vue?vue&type=script&lang=js&"
export * from "./Stament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports